import Image from "next/image";
import { urlForImage } from "@/lib/sanity";

export default function Avatar({ name, picture }) {
  return (
    <div className="grid grid-cols-[20px_auto] items-center gap-x-4">
      <Image
        src={urlForImage(picture).height(96).width(96).fit("crop").url()}
        width={20}
        height={20}
        className="rounded-full"
        alt={name}
      />
      <div className="font-semibold">{name}</div>
    </div>
  );
}
